import type { Color } from "@mui/material/styles";

export const aquamarine = {
  50: "#E0F2F1",
  100: "#B2DFDB",
  200: "#80CBC4",
  300: "#4DB6AC",
  400: "#26A69A",
  500: "#00897B",
  600: "#00796B",
  700: "#00695C",
  800: "#004D40",
  900: "#00251A",
  A100: "#B2DFDB",
  A200: "#80CBC4",
  A400: "#26A69A",
  A700: "#00695C",
} satisfies Color;
